import "core-js/modules/es.array.reduce.js";

var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import i18n from '@pureartisan/simple-i18n';
import { CHORO_COLORS, CHORO_STROKE } from '../../../../constants/colors';
import shallow from 'zustand/shallow';
import useStore from '../store';
/**
 * Button group container
 */

var ToggleGroup = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  padding-top: 32px;\n  & > .btn + .btn {\n    margin-left: 4px;\n  }\n  &.no-labels {\n    padding-top: 0;\n    & .btn span {\n      opacity: 0;\n    }\n    & .btn:before {\n      opacity: 0;\n    }\n  }\n  &.condensed {\n    & .btn {\n      height: 16px;\n    }\n  }\n"])));
/**
 * Button element for each choropleth
 */

var ChoroplethToggle = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  border: 1px solid;\n  flex: 1;\n  position: relative;\n  height: 24px;\n  background: #eee;\n  border-color: #ddd;\n  // larger width for middle item\n  &:nth-child(3) {\n    flex: 3;\n  }\n  // labels\n  & > span {\n    position: absolute;\n    bottom: 32px;\n    text-align: center;\n    line-height: 1;\n    left: 0;\n    right: 0;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    pointer-events: none;\n  }\n  // line indicator above buttons\n  &:before {\n    content: ' ';\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 4px;\n    box-shadow: 1px -1px 0 #8c95a1, -1px -1px 0 #8c95a1;\n    left: 0;\n    top: -6px;\n    right: 0;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n  }\n  // first label\n  &:nth-child(1) > span {\n    text-align: left;\n    width: 72px;\n  }\n  // middle label\n  &:nth-child(3) > span {\n    margin: auto;\n    width: 56px;\n  }\n  // last label\n  &:nth-child(5) > span {\n    text-align: right;\n    width: 72px;\n    left: auto;\n    right: 0;\n  }\n  // up the opacity when showing the label\n  &.show-label {\n    &:before {\n      opacity: 1;\n    }\n    & > span {\n      opacity: 1;\n    }\n  }\n  // add colors for \"on\" state\n  &.on {\n    &:nth-child(1) {\n      background-color: ", ";\n      border-color: ", ";\n      &:not(.disabled):hover {\n        background-color: ", ";\n      }\n    }\n    &:nth-child(2) {\n      background-color: ", ";\n      border-color: ", ";\n      &:not(.disabled):hover {\n        background-color: ", ";\n      }\n    }\n    &:nth-child(3) {\n      background-color: ", ";\n      border-color: ", ";\n      &:not(.disabled):hover {\n        background-color: ", ";\n      }\n    }\n    &:nth-child(4) {\n      background-color: ", ";\n      border-color: ", ";\n      &:not(.disabled):hover {\n        background-color: ", ";\n      }\n    }\n    &:nth-child(5) {\n      background-color: ", ";\n      border-color: ", ";\n      &:not(.disabled):hover {\n        background-color: ", ";\n      }\n    }\n    &.disabled {\n      opacity: 1;\n    }\n  }\n"])), CHORO_COLORS[0], CHORO_STROKE[0], CHORO_STROKE[0], CHORO_COLORS[1], CHORO_STROKE[1], CHORO_STROKE[1], CHORO_COLORS[2], CHORO_STROKE[2], CHORO_STROKE[2], CHORO_COLORS[3], CHORO_STROKE[3], CHORO_STROKE[3], CHORO_COLORS[4], CHORO_STROKE[4], CHORO_STROKE[4]);
export var ChoroplethLegend = function ChoroplethLegend(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      interactive = _ref.interactive,
      noLabels = _ref.noLabels,
      condensed = _ref.condensed,
      _ref$activeIndexes = _ref.activeIndexes,
      defaultActiveIndexes = _ref$activeIndexes === void 0 ? [0, 1, 2, 3, 4] : _ref$activeIndexes,
      _ref$labelIndexes = _ref.labelIndexes,
      defaultLabelIndexes = _ref$labelIndexes === void 0 ? [0, 2, 4] : _ref$labelIndexes,
      onClick = _ref.onClick,
      onHover = _ref.onHover,
      props = _objectWithoutPropertiesLoose(_ref, ["classes", "className", "interactive", "noLabels", "condensed", "activeIndexes", "labelIndexes", "onClick", "onHover"]);

  var hoverRef = useRef();

  var _useState = useState(defaultLabelIndexes),
      labelIndexes = _useState[0],
      setLabelIndexes = _useState[1];

  var _useState2 = useState(defaultActiveIndexes),
      activeIndexes = _useState2[0],
      setActiveIndexes = _useState2[1]; // update local state if new label indexes are provided


  useEffect(function () {
    if (!shallow(defaultLabelIndexes, labelIndexes) && !hoverRef.current) {
      setLabelIndexes(defaultLabelIndexes);
    }
  }, [defaultLabelIndexes, labelIndexes, setLabelIndexes]); // update local state if new active indexes are provided

  useEffect(function () {
    if (!shallow(defaultActiveIndexes, activeIndexes)) {
      setActiveIndexes(defaultActiveIndexes);
    }
  }, [defaultActiveIndexes, activeIndexes, setActiveIndexes]);
  /** Update the labels when hovering */

  var handleToggleEnter = function handleToggleEnter(event) {
    if (!interactive) return;
    hoverRef.current = labelIndexes;
    setLabelIndexes([Number(event.target.value)]);
    onHover && onHover(event);
  };
  /** Restore the label state when done hovering */


  var handleToggleLeave = function handleToggleLeave(event) {
    if (!interactive) return;
    hoverRef.current && setLabelIndexes(hoverRef.current);
    hoverRef.current = null;
    onHover && onHover(event);
  };
  /** Trigger event when clicking */


  var handleToggleClick = function handleToggleClick(event) {
    if (!interactive) return;
    onClick && onClick(event);
  };
  /** Text for each toggle */


  var toggles = [i18n.translate("UI_MAP_LEGEND_FEWER"), 'Below Average', i18n.translate("UI_MAP_LEGEND_AVG"), 'Above Average', i18n.translate("UI_MAP_LEGEND_MORE")];
  return /*#__PURE__*/React.createElement(ToggleGroup, _extends({
    onMouseLeave: handleToggleLeave,
    role: "group",
    className: clsx('choropleth-legend', {
      'no-labels': noLabels,
      condensed: condensed
    }, className)
  }, props), toggles.map(function (toggle, i) {
    return /*#__PURE__*/React.createElement(ChoroplethToggle, {
      key: toggle,
      color: "none",
      value: i,
      className: clsx('knockout12', 'grey2', {
        'show-label': labelIndexes.includes(i),
        on: activeIndexes.includes(i)
      }),
      onMouseEnter: handleToggleEnter,
      onClick: handleToggleClick,
      "aria-label": "toggle " + toggle,
      disabled: !interactive
    }, /*#__PURE__*/React.createElement("span", null, toggle));
  }));
};
export var ConnectedChoroplethLegend = function ConnectedChoroplethLegend(props) {
  var _useStore = useStore(function (state) {
    return [state.activeQuintiles, state.setStoreValues];
  }, shallow),
      activeQuintiles = _useStore[0],
      setStoreValues = _useStore[1];
  /** Memoized active indexes */


  var activeIndexes = useMemo(function () {
    return activeQuintiles.reduce(function (indexes, current, i) {
      if (current === 1) indexes.push(i);
      return indexes;
    }, []);
  }, [activeQuintiles]);
  var handleToggle = useCallback(function (event) {
    var index = Number(event.target.value);
    var newActiveQuintiles = activeQuintiles.map(function (q, i) {
      return i === index ? Number(!q) : q;
    });
    setStoreValues({
      activeQuintiles: newActiveQuintiles
    });
  }, [setStoreValues, activeQuintiles]);
  return /*#__PURE__*/React.createElement(ChoroplethLegend, _extends({
    activeIndexes: activeIndexes,
    onClick: handleToggle
  }, props));
};
export default ConnectedChoroplethLegend;